import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO12 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK001-2.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO12
